module.exports = __webpack_public_path__ + "img/logo-header-dark-mobile.ece9cf7d.png";